module.exports = __webpack_public_path__ + "img/haikei_refly.0feebb46.jpg";